<template>
  <!-- 导航栏-->
  <div class="main">
    <div class="nav-wrap">
      <div class="nav-box">
        <div class="nav-div">
          <div class="nav-left">
            <div class="logo">
              <img src="~@/assets/img/logo.png" alt="logo" @click="toHome">
            </div>
          </div>
          <div class="nav-right" v-if="$store.getters.userToken">
            <div class="kfc-account">
              <div class="kfc-div">
                <div v-if="platformName">
                  <img class="avatar" v-if="headImg" :src="headImg" alt="">
                  <img class="avatar" v-else src="~@/assets/img/kfc/weishouquan.png" alt="">
                </div>
                <div class="account-name">{{ platformName }}</div>
                <div class="change-wrap">
                  <span @click="changeAccount()" class="show-change" v-if="publicList.length > 1">切换公众号</span>
                  <div class="dialog-warp">
                    <div class="kfc-dialog-box" v-if="isShowAccount">
                      <span class="bot"></span>
                      <span class="top"></span>
                      <div class="kfc-item">
                        <div class="kfc-item-div" v-for="(item, index) of publicList" :key="index">
                          <img v-if="item.headImg" :src="item.headImg" alt="">
                          <img v-else src="~@/assets/img/kfc/weishouquan.png" alt="">
                          <div class="account-name color-666">{{ item.platformName }}</div>
                          <div class="item-change" @click="changePubilc(item)">切换</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="user">
              <div class="user-div">
                <img class="avatar" v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
                <img class="avatar" v-else src="~@/assets/img/kfc/head.png" alt="">
                <div class="nickname">{{ userInfo ? userInfo.nickname : '' }}</div>
                <div class="arrow-img">
                  <img @click="changeArrow()" :src="this.arrowIcon" alt="">
                  <div class="nav-dialog-box" v-if="isShow">
                    <span class="bot"></span>
                    <span class="top"></span>
                    <div class="nav-item">
                      <div @click="toPromotion" :class="(activeItem == 0) ? 'active' : ''">我的推广位</div>
                      <div @click="toMyWechat" :class="(activeItem == 1) ? 'active' : ''">影票公众号</div>
                      <!--                      <div @click="toMyKfcWechat" :class="(activeItem == 3) ? 'active':''">肯德基公众号</div>-->
                      <div @click="toLogout" :class="(activeItem == 2) ? 'active' : ''">退出</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
  <!-- 导航栏-->
</template>

<script>
import { getUserInfo, getUserUUID, setPlatformNameKfc, getPlatformUuidKfc, setPlatformUuidKfc, setIsAuthKfc, setHeadImgKfc } from '@/utils/auth'
import navArrowDowm from '@/assets/img/kfc/nav_btn_arrow_down.png'
import navArrowUp from '@/assets/img/kfc/nav_btn_arrow_upward.png'
import noHeadImg from '@/assets/img/kfc/weishouquan.png'
import kfc from '@/javaApi/kfc/kfc'
const kfcModel = new kfc()
import official from '@/javaApi/official'
const officialModel = new official()
export default {
  name: "KfcNav",
  components: {
    navArrowDowm,
    navArrowUp,
    noHeadImg
  },
  data: function () {
    return {
      userInfo: {},
      isShowAccount: false,
      isShow: false,
      arrowIcon: navArrowDowm,
      listLoading: false,
      publicList: [],
    }
  },
  mounted() {
    this.$store.dispatch('nav/changePersonalActiveIndex', 3)
    this.userInfo = getUserInfo()
    this.getHasAuthPubilc();
  },
  computed: {
    activeItem: function () {
      return this.$store.getters.personalActiveIndex
    },
    platformName: function () {
      return this.$store.getters.platformNameKfc || ''
    },
    headImg: function () {
      return this.$store.getters.headImgKfc || ''
    },
  },
  methods: {
    changeAccount() {
      if (this.isShowAccount === false) {
        this.getHasAuthPubilc();
        this.isShowAccount = true
        this.isShow = false
      } else {
        this.isShowAccount = false
      }
    },
    //获取公众号信息
    getHasAuthPubilc() {
      this.listLoading = true
      officialModel.getAuthPublicList({ openUserUuid: getUserUUID() }).then((response) => {
        this.listLoading = false
        var res = response.data
        if (res.success) {
          if (res.data && res.data.binds && res.data.binds.length > 0) {
            this.publicList = res.data.binds
            // 默认数据取第一条
            if (getPlatformUuidKfc() === '') {
              // 取第一条公众号数据，做为默认公众号
              var defaultKfc = res.data.binds[0];
              setPlatformUuidKfc(defaultKfc.platformUuid) // 公众号UUID
              setPlatformNameKfc(defaultKfc.platformName) // 公众号名称
              setHeadImgKfc(defaultKfc.headImg) // 公众号logo
              // 公众号是否已授权
              if (defaultKfc.platformUuid !== '' && defaultKfc.platformName !== '') {
                setIsAuthKfc(true)
              } else {
                setIsAuthKfc(false)
              }
              this.$store.dispatch('kfc/changePlatformNameKfc', defaultKfc.platformName)
              this.$store.dispatch('kfc/changeHeadImgKfc', defaultKfc.headImg)
            }
          } else {
            setPlatformUuidKfc(0);
            setPlatformNameKfc('')
            setHeadImgKfc('')
            setIsAuthKfc(false)
            this.isAuth = false
            this.$store.dispatch('kfc/changePlatformNameKfc', '')
            this.$store.dispatch('kfc/changeHeadImgKfc', '')
          }
        } else {
          setPlatformUuidKfc(0);
          setPlatformNameKfc('')
          setHeadImgKfc('')
          setIsAuthKfc(false)
          this.isAuth = false
          this.$store.dispatch('kfc/changePlatformNameKfc', '')
          this.$store.dispatch('kfc/changeHeadImgKfc', '')
          this.$Message.error(res.message)
          return
        }
      }).catch(error => {
        console.log(error)
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    //切换公众号
    changePubilc(row) {
      var that = this;
      that.$Message.success('公众号切换中...');
      setPlatformUuidKfc(row.platformUuid);
      setPlatformNameKfc(row.platformName)
      setHeadImgKfc(row.headImg)
      this.$store.dispatch('kfc/changePlatformNameKfc', row.platformName)
      this.$store.dispatch('kfc/changeHeadImgKfc', row.headImg)
      if (row.platformUuid !== '' && row.platformName !== '') {
        setIsAuthKfc(true)
      } else {
        setIsAuthKfc(false)
      }
      that.$router.go(0)
    },
    changeArrow() {
      if (this.isShow === false) {
        this.isShow = true
        this.isShowAccount = false
        this.arrowIcon = navArrowUp
      } else {
        this.isShow = false
        this.arrowIcon = navArrowDowm
      }
    },
    //跳转到我的邀请
    toInvite() {
      var that = this
      that.$store.dispatch('nav/changeKfcAccountActiveIndex', 1)
      that.$router.push('/pc/kfc/invite').catch(err => { err })
      this.$store.dispatch('nav/changePersonalActiveIndex', 0)
    },
    toLogout() {
      this.$store.dispatch('nav/changePersonalActiveIndex', 2)
      this.$store.dispatch('user/logout')
      this.$Message.success('退出成功')
      this.$router.push('/')
    },
    // 跳转到我的推广位
    toPromotion() {
      this.$router.push('/pc/promotion/home').catch(err => { err })
      this.$store.dispatch('nav/changePersonalActiveIndex', 0)
    },
    //跳转到我的公众号
    toMyWechat() {
      this.$router.push('/pc/official/mywechat').catch(err => { err })
      this.$store.dispatch('official/changeIsShowSlide', true)
      this.$store.dispatch('nav/changePersonalActiveIndex', 1)
      this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 1)
    },
    //肯德基公众号
    toMyKfcWechat() {
      this.$router.push('/pc/kfc/mywechat').catch(err => { err })
      this.$store.dispatch('nav/changePersonalActiveIndex', 3)
    },
    //跳转到首页
    toHome() {
      let isSaas = localStorage.getItem('isSaas')
      if (isSaas == 1) {
        this.$router.push({ path: '/pc/home', query: { type: 'saasmovie' } })
      } else {
        this.$router.push('/pc/home')
      }
    },
    // 添加公众号
    toAuthorization() {
      setPlatformUuidKfc(0);
      setPlatformNameKfc('')
      setHeadImgKfc('')
      setIsAuthKfc(false)
      this.$store.dispatch('kfc/changePlatformNameKfc', '')
      this.$store.dispatch('kfc/changeHeadImgKfc', '')
      this.$router.push({
        path: '/pc/kfc/mywechat',
        query: { is_new: 1 }
      }).catch(err => { err })
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}

.nav-wrap {
  height: 80px;
  background: #ffffff;
}

.nav-wrap .nav-box {
  /* width: 60%; */
  /* margin: 0 auto; */
  /* min-width: 850px; */
  margin: 0 13.5%
}

.nav-wrap .nav-box .nav-div {
  width: 100%;
  height: 80px;
}

.nav-wrap .nav-box .nav-div .nav-left {
  float: left;
  width: 178px;
}

.nav-wrap .nav-box .nav-div .nav-left .logo {
  width: 178px;
  height: 80px;
  background: #FF8622;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.nav-wrap .nav-box .nav-div .nav-left .logo img {
  /* height: 58px; */
  width: 100%;
}

.nav-right {
  float: right;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nav-right .kfc-account {
  float: right;
  height: 80px;
  font-size: 16px;
  color: #666666;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}

.nav-right .kfc-account .kfc-div {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nav-right .kfc-account .kfc-div .show-change {
  color: #3D9EFC;
  font-size: 12px;
  cursor: pointer;
}

/* 切换公众号 */
.change-wrap {
  position: relative;
}

.change-wrap .dialog-warp {
  position: absolute;
  left: -40px;
}

/* 切换公众号 */
.nav-right .kfc-account .avatar {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.nav-right .kfc-account .account-name {
  font-size: 13px;
  color: #666666;
  max-width: 80px;
  margin: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
}

.nav-right .auth-btn {
  font-family: Alibaba-PuHuiTi-R;
  background: #D63036;
  border-radius: 2px;
  color: #FFFFFF;
  padding: 6px 15px;
  cursor: pointer;
  margin-right: 20px;
}

.nav-right .kfc-account {
  float: right;
  height: 80px;
  font-size: 16px;
  color: #666666;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}

.nav-right .kfc-account .kfc-div {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nav-right .kfc-account .arrow-img {
  width: 20px;
}

.nav-right .user {
  float: right;
  height: 80px;
  font-size: 16px;
  color: #666666;
}

.nav-right .user .user-div {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nav-right .user .avatar {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.nav-right .user .nickname {
  font-size: 13px;
  color: #666666;
  max-width: 80px;
  margin: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: clip;
  text-overflow: ellipsis;
}

.nav-right .user .arrow-img {
  width: 20px;
  cursor: pointer;
  position: relative;
}

.nav-right .user .arrow-img img {
  width: 100%;
}

.nav-right .nav-dialog-box {
  background: #FFFFFF;
  width: 100px;
  position: absolute;
  bottom: -10px;
  left: -40px;
  border-top: 1px solid #EEEEEE;
}

.nav-right .nav-dialog-box span {
  width: 0;
  height: 0;
  font-size: 0;
  overflow: hidden;
  position: absolute;
}

.nav-right .nav-dialog-box .bot {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #EEEEEE transparent;
  left: 44%;
  top: -16px;
}

.nav-right .nav-dialog-box .top {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #FFFFFF transparent;
  left: 44%;
  top: -15px;
}

.nav-right .nav-dialog-box .nav-item {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #666666;
  line-height: 36px;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-top: none;
  z-index: 999;
  cursor: pointer;
}

.nav-right .nav-dialog-box .nav-item div {
  height: 36px;
}

.nav-right .nav-dialog-box .nav-item .active {
  background: #FCFAF8;
  color: #D63036;
}

.nav-right .kfc-dialog-box {
  background: #FFFFFF;
  width: 160px;
  position: relative;
  top: 8px;
  border-top: 1px solid #EEEEEE;
}

.nav-right .kfc-dialog-box span {
  width: 0;
  height: 0;
  font-size: 0;
  overflow: hidden;
  position: absolute;
}

.nav-right .kfc-dialog-box .bot {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #EEEEEE transparent;
  left: 44%;
  top: -16px;
}

.nav-right .kfc-dialog-box .top {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #FFFFFF transparent;
  left: 44%;
  top: -15px;
}

.nav-right .kfc-dialog-box .kfc-item {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #666666;
  line-height: 36px;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-top: none;
  z-index: 999;
}

.nav-right .kfc-dialog-box .kfc-item .kfc-item-div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nav-right .kfc-dialog-box .kfc-item .kfc-item-div img {
  margin: 8px 0 8px 8px;
}

.nav-right .kfc-dialog-box .kfc-item .kfc-item-div .item-change {
  color: #3D9EFC;
  cursor: pointer;
}

.nav-right .kfc-dialog-box .kfc-item img {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.nav-right .kfc-dialog-box .kfc-item .active {
  background: #FCFAF8;
  color: #D63036;
}

/* @media (min-width: 768px) {
    .nav-wrap .nav-box {
      width: 85%;
    }
  }
  @media (min-width: 992px) {
    .nav-wrap .nav-box {
      width: 80%;
    }
  }
  @media (min-width: 1200px) {
    .nav-wrap .nav-box {
      width: 70%;
    }
  }
  @media (min-width: 1400px) {
    .nav-wrap .nav-box {
      width: 62.5%;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/KfcNav.vue